import { PriceDisplay } from 'src/components/price-list/types';
import { pushEvent } from '../../../client/data-layer';
import { Price, Variant as VariantType, VariantGroup } from '../../../types';

// Tracks when the user changes the "price inc shipping" option, which affects prices
export const trackPriceListSortUpdate = (sort: PriceDisplay) => {
  pushEvent('priceListSortUpdate', { sort });
};

// Tracks when the user change a filter for the offerlist
export const trackPriceListFilterUpdate = (
  selectedFilter: string,
  checked: boolean
) => {
  pushEvent('priceListFilterUpdate', { selectedFilter, checked });
};

export const trackProductCompareTopTenLinkClick = (productId: number) =>
  pushEvent('productCompareTopTenLinkClicked', { productId });

// Tracks when the user selects a product variant
export const trackProductVariantClick = (
  group: VariantGroup,
  variant: VariantType | null
) => {
  pushEvent('priceListVariantSelected', {
    variantGroupId: group.id,
    variantGroupName: group.name,
    variantGroupType: group.type,
    variantId: variant?.id,
    variantName: variant?.name,
  });
};

type ProductSizeVariantClickoutData = {
  isVariantFiltered: boolean;
  isPrimaryList: boolean;
};

export const trackProductSizeVariantClickout = (
  data: ProductSizeVariantClickoutData
) => {
  pushEvent('productSizeVariantClickout', data);
};

export type OurChoiceExperimentClickOutData = {
  price: Price;
  isOurChoice: boolean;
  position?: 'productHeader' | 'offerList';
  offerListPosition?: number;
};

export const trackOurChoiceExperimentClickOut = (
  data: OurChoiceExperimentClickOutData
) => pushEvent('ourChoiceExperimentClickOut', data);
